module.exports = __webpack_public_path__ + "static/shirt-aeb84c831aa110c7418983a79b6c4dea.gif";